import { commonFilter } from './filter';

const pageId = '24021';

export default {
  pageName: 'Compare Key Metrics',
  pageId,
  pagePath: '/opinion/Overview/CompareKeyMetrics',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    CKMS_Location: {
      buttonId: '2402101',
    },
    CKMS_MetricsTAB: {
      buttonId: '2402102',
    },
    CKMS_ByMetricsType: {
      buttonId: '2402107',
    },
    CKGS_StoreMetricsTAB: {
      buttonId: '2402201',
    },
    CKGS_RatingMetricsTAB: {
      buttonId: '2402202',
    },
    CKC_TypeTAB: {
      buttonId: '2402301',
    },
    CKC_Metrics: {
      buttonId: '2402302',
    },
    CKSteam_ReviewsMetricsTAB: {
      buttonId: '2402601',
    },
    CKSteam_SELECT: {
      buttonId: '2402608',
    },
    CKGS_SELECT: {
      buttonId: '2402209',
    },
    ...commonFilter,
  },
  card: {
    'Mentions & Sentiment': {
      table: {
        buttonId: '2402103',
      },
      line: {
        buttonId: '2402104',
      },
      bar: {
        buttonId: '2402105',
      },
      download: {
        buttonId: '2402106',
      },
    },
    'Mentions & Sentiment Table': {
      download: {
        buttonId: '2402108',
      },
    },
    'Mobile Game Store': {
      table: {
        buttonId: '2402203',
      },
      line: {
        buttonId: '2402204',
      },
      bar: {
        buttonId: '2402205',
      },
      download: {
        buttonId: '2402206',
      },
    },
    'Mobile Game Store Table': {
      download: {
        buttonId: '2402207',
      },
    },
    Community: {
      table: {
        buttonId: '2402303',
      },
      line: {
        buttonId: '2402304',
      },
      bar: {
        buttonId: '2402305',
      },
      download: {
        buttonId: '2402306',
      },
    },
    'Community Table': {
      download: {
        buttonId: '2402307',
      },
    },
    PR: {
      table: {
        buttonId: '2402401',
      },
      line: {
        buttonId: '2402402',
      },
      bar: {
        buttonId: '2402403',
      },
      download: {
        buttonId: '2402404',
      },
    },
    'PR Table': {
      download: {
        buttonId: '2402405',
      },
    },
    'Google Trends': {
      table: {
        buttonId: '2402501',
      },
      line: {
        buttonId: '2402502',
      },
      bar: {
        buttonId: '2402503',
      },
      download: {
        buttonId: '2402504',
      },
    },
    'Steam Game Store': {
      table: {
        buttonId: '2402602',
      },
      line: {
        buttonId: '2402603',
      },
      bar: {
        buttonId: '2402604',
      },
      download: {
        buttonId: '2402605',
      },
    },
    'Steam Game Store Table': {
      download: {
        buttonId: '2402606',
      },
    },
  },
  table: {
    'Mentions & Sentiment': {
      Sort: {
        buttonId: '2402109',
      },
    },
    'Mobile Game Store': {
      Sort: {
        buttonId: '2402208',
      },
    },
    Community: {
      Sort: {
        buttonId: '2402308',
      },
    },
    PR: {
      Sort: {
        buttonId: '2402406',
      },
    },
    'Steam Game Store': {
      Sort: {
        buttonId: '2402607',
      },
    },
  },
};
